import {
  CarrierSurchargesOverTimeRequestSchema,
  CarrierSurchargesOverTimeResponseSchema,
} from "@redotech/redo-model/fulfillments/metrics";

export const getCarrierSurchargesOverTime = {
  name: "getCarrierSurchargesOverTime" as const,
  input: CarrierSurchargesOverTimeRequestSchema,
  output: CarrierSurchargesOverTimeResponseSchema,
};
